import { AxiosInstance } from 'axios';
import { getExportConfig, handleFileExport } from '../../../../../../helpers/fileExport';
import { NATIONALITY_FORECAST_REPORT_ENDPOINT } from '../endpoint';
import { NationalityForecastReportRequestModel } from '../models/NationalityForecastReportRequestModel';

export const exportPDF =
  (axios: AxiosInstance) =>
  async (params?: NationalityForecastReportRequestModel): Promise<void> => {
    return await axios
      .get(`${NATIONALITY_FORECAST_REPORT_ENDPOINT}`, {
        params: { ...params },
        ...getExportConfig(params),
      })
      .then(response => {
        handleFileExport(response, {
          file_type: params?.file_type,
          filename: 'nationality-forecast-report',
        });
      });
  };
